import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { GetCartListAction } from "../../redux/actions/PaymentActions";
import { Helmet } from 'react-helmet';

import stripe_logo from '../../assets/images/stripe_logo.png';
import paypal_logo from '../../assets/images/paypal_logo.jpg';
import PayUMoney_logo from '../../assets/images/PayUMoney_logo.jpg';

import stripeImg from '../../assets/images/stripe1.png';
import paypalImg from '../../assets/images/Paypal.png';
import payumoneyImg from '../../assets/images/payumoney.png';


import './checkout.css';


type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

const Checkout: React.FC = () => {

    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);
  const { loading, status, data, error } = useSelector((state: any) => state.cartDataState || []);
    const [dataList, setDataList] = useState<any[]>([]);
    const [subTotal, setSubTotal] = useState(0);

  // 👉 Fetch cart on mount
  useEffect(() => {
    dispatch(GetCartListAction({}));
  }, [dispatch]);

  // 👉 Update dataList when redux data changes
  useEffect(() => {
    if (data) {
      setDataList(data);
    }
  }, [data, status, error]);

  // 👉 Recalculate subtotal when dataList changes
  useEffect(() => {
    const total = dataList.reduce(
      (sum, item) => sum + (item?.price || 0),
      0
    );
    setSubTotal(total);
  }, [dataList]);

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Checkout'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <>
        {/* Checkout Header */}
        <div className="checkout-header">
          <div className="container text-center">
            <h1 className="fw-bold mb-3">Complete Your Purchase</h1>
            <p className="mb-0">Secure checkout with multiple payment options</p>
          </div>
        </div>

        {/* Checkout Content */}
        <div className="container">
          <div className="row">
            {/* Checkout Form Column */}
            <div className="col-lg-8 mb-4">
              <div className="checkout-container">
                <h2 className="mb-4">Pay via</h2>
                <div className="mb-4">
                  <div className="payment-method active" id="creditCardMethod">

                    <div className="payment-method-icon text-primary">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="creditCardRadio"
                          defaultChecked
                        />
                    </div>
                    </div>
                    <div className="payment-method-details">
                      <label className="form-check-label d-flex align-items-center gap-2" htmlFor="stripe">
                        <img src={stripe_logo} alt="Stripe" style={{ width: '20%' }} />
                        Stripe (For all currency payments using credit or debit card)
                      </label>
                    </div>
                  </div>

                  <div className="payment-method" id="paypalMethod">
                    <div className="payment-method-icon text-primary">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="paypalRadio"
                        />
                      </div>
                    </div>
                    <div className="payment-method-details">
                    <label className="form-check-label d-flex align-items-center gap-2" htmlFor="paypal">
                      <img src={paypalImg} alt="PayPal" style={{ width: '20%' }} />
                      PayPal (If you want to use PayPal)
                    </label>
                    </div>
                  </div>

                  <div className="payment-method" id="payuMethod">
                    <div className="payment-method-icon text-primary">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="payuRadio"
                        />
                      </div>                      
                    </div>
                    <div className="payment-method-details">
                      <label className="form-check-label d-flex align-items-center gap-2" htmlFor="payumoney">
                        <img src={payumoneyImg} alt="PayU Money" style={{ width: '20%' }} />
                        PayU Money (For all INR payments)
                      </label>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* Order Summary Column */}
            <div className="col-lg-4">
              <div className="checkout-container sticky-top" style={{ top: "20px" }}>
                <h3 className="section-title">Order Summary</h3>
                {/* Course Items */}
                <div className="mb-4">
                  {dataList.length > 0 && (
                    dataList.map((item: any) => (
                      <div className="course-item" key={item.id}>
                        <span className="cart-custom-icon-checkout">
                          {item?.category?.icon}
                        </span>
                        <div className="course-item-details">
                          <h6 className="course-item-title">{item?.category?.name}</h6>
                          <p className="course-item-instructor">{item?.category?.single_line}</p>
                        </div>
                        <div className="course-item-price">{item?.currency} {item?.price}</div>
                      </div>
                    ))
                  )}
                </div>
                {/* Order Summary */}
                <div className="mb-3">
                  <div className="order-summary-item">
                    <span>Subtotal ({dataList.length === 1 ? "item" : "items"})</span>
                    <span>{dataList[0]?.currency || ""} {subTotal.toFixed(2)}</span>
                  </div>
                  <div className="order-summary-item">
                    <span>Discount</span>
                    <span className="text-success">- {dataList[0]?.currency || ""} 00.00</span>
                  </div>
                  
                  <div className="order-summary-item order-summary-total">
                    <span>Total</span>
                    <span>{subTotal.toFixed(2)}</span>
                  </div>
                </div>
                <Link to="/order-confirmation" className="btn-checkout text-decoration-none d-inline-flex align-items-center justify-content-center gap-2">
                    <i className="bi bi-lock-fill me-2"></i>Complete Purchase
                </Link>
                
                <div className="secure-badge">
                  <i className="bi bi-shield-check"></i>
                  <span>Secure SSL Encryption</span>
                </div>

                <div className="mt-3">
                  <p className="small text-muted">
                    By completing your purchase, you agree to our{" "}
                    <Link to="#">Terms of Service</Link> and{" "}
                    <Link to="#">Privacy Policy</Link>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

      <Footer />
    </>
  );
};

export default Checkout;
